import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import Icon from '@ant-design/icons/lib/components/Icon';
import myIconWhite from '@public/images-mobile/game-room/my_icon.svg';
import MyIconBlack from '@public/images-mobile/game-room/my_icon_black.svg';
import styles from './styles';
import PlayerIcon from '@components/PlayerIcon';
// import Poker from '@components/Poker';
// import classnames from 'classnames';

const PlayerAvatarChipBorder = (props: {
  icon: JSX.Element | string;
  // eslint-disable-next-line react/no-unused-prop-types
  iconWidthPx?: number;
  className?: string;
  isBlackBorder?: boolean;
  isImagePreview?: boolean;
}): JSX.Element => {
  const {icon, className, isBlackBorder, isImagePreview} = props;
  const {classes} = useCommon({
    withStyles: {styles, hasProps: true, props},
  });

  return (
    <div className={classNames(classes.playerIconContainer, className)}>
      <Icon // TODO icon bug
        // component={isBlackBorder ? myIconBlack : myIconWhite}
        component={MyIconBlack}
        className={classes.playerAvatarBorder}
      />
      {/* {isBlackBorder ? (
        <MyIconBlack className={classes.playerAvatarBorder} />
      ) : (
        <MyIconWhite className={classes.playerAvatarBorder} />
      )} */}
      <span className={classes.playerAvatar}>
        <PlayerIcon icon={icon} isImagePreview={isImagePreview} />
      </span>
    </div>
  );
};

export default PlayerAvatarChipBorder;
